// extracted by mini-css-extract-plugin
export default {"LoaderContainer":"Loader_LoaderContainer__xjM+j"};